import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaLinkedin } from 'react-icons/fa';
import { useLanguage } from '../../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  
  // Couleurs définies pour la cohérence
  const redColor = "#d90000";
  const textColor = "#cbd5e1"; // Gris argenté (plus lisible et reposant)

  return (
    <footer className="footer-custom" style={{ backgroundColor: '#0f172a', padding: '60px 0 30px' }}>
      <Container>
        <Row>
          {/* 1. LOGO ET DESCRIPTION */}
          <Col lg={6} md={6} className="mb-4">
            <img 
              src="/images/logo.png" 
              alt="S2i Logo" 
              style={{ height: 70, marginBottom: 16 }} 
            />
            <p style={{ color: textColor, marginBottom: 24, fontSize: '0.95rem', lineHeight: '1.6', maxWidth: '450px' }}>
              {t.footer.desc}
            </p>
            <div className="social-links">
              <a 
                href="https://www.linkedin.com/company/s2i-tunisie" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ 
                  display: 'inline-flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  width: 40, 
                  height: 40, 
                  borderRadius: '50%', 
                  background: redColor, 
                  color: '#fff', 
                  fontSize: 22,
                  transition: '0.3s'
                }}
                className="linkedin-hover"
              >
                <FaLinkedin />
              </a>
            </div>
          </Col>

          {/* 2. SERVICES LIENS */}
          <Col lg={3} md={3} className="mb-4">
            <h5 style={{ color: redColor, fontWeight: 700, marginBottom: 20 }}>{t.footer.servicesTitle}</h5>
            <ul className="list-unstyled">
              {[
                { link: "/services/analyse-conseil", text: t.footer.s1 },
                { link: "/services/analyse-conseil#conseil", text: t.footer.s2 },
                { link: "/services/implementation-support#support", text: t.footer.s3 },
                { link: "/services/implementation-support", text: t.footer.s4 }
              ].map((item, index) => (
                <li key={index} className="mb-2">
                  <a 
                    href={item.link} 
                    style={{ color: textColor, textDecoration: 'none', fontSize: '0.95rem', transition: '0.3s' }}
                    className="footer-link"
                  >
                    {item.text}
                  </a>
                </li>
              ))}
            </ul>
          </Col>

          {/* 3. CONTACT INFO */}
          <Col lg={3} md={3} className="mb-4">
            <h5 style={{ color: redColor, fontWeight: 700, marginBottom: 20 }}>{t.footer.contactTitle}</h5>
            <div className="contact-info" style={{ color: textColor, fontSize: '0.95rem' }}>
              <div className="d-flex align-items-start mb-3">
                <FaMapMarkerAlt className="me-3" style={{ color: redColor, fontSize: '1.2rem', marginTop: '4px' }}/>
                <span>Rue des Entrepreneurs, Immeubles Hertz Bloc B 1er Etage, Tunis</span>
              </div>
              <div className="d-flex align-items-center mb-3">
                <FaPhone className="me-3" style={{ color: redColor }} />
                <span>+216 70 839 470</span>
              </div>
              <div className="d-flex align-items-center">
                <FaEnvelope className="me-3" style={{ color: redColor }} />
                <a href="mailto:s2iteam@s2i.com.tn" style={{ color: textColor, textDecoration: 'none' }}>s2iteam@s2i.com.tn</a>
              </div>
            </div>
          </Col>
        </Row>

        <hr style={{ borderTop: '1px solid rgba(255,255,255,0.1)', margin: '40px 0 20px' }} />

        {/* 4. COPYRIGHT */}
        <Row>
          <Col className="text-center">
            <p className="mb-0" style={{ color: textColor, opacity: 0.7, fontSize: '0.85rem' }}>
              &copy; {new Date().getFullYear()} S2i - {t.footer.rights}
            </p>
          </Col>
        </Row>
      </Container>

      {/* Styles pour les effets de survol (Hover) */}
      <style>{`
        .footer-link:hover {
          color: ${redColor} !important;
          padding-left: 5px;
        }
        .linkedin-hover:hover {
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(217, 0, 0, 0.4);
        }
      `}</style>
    </footer>
  );
};

export default Footer;